import {API} from "@/api/generated";
import {defineStore} from "pinia";
import {stateUser, user} from "@/page/setting/account/userTypes";

export const useUserStore = defineStore("userData", {
  state: (): stateUser => ({
    user: {
      _id: "",
      name: "",
      phone: "",
      email: "",
      emailsInApplications: [],
      domain: [],
      idsTelegramInApplications: [],
      password: "",
      status: "",
      identIntegrationKey: [],
      macDentIntegrationKey: [],
      create: "",
      update: "",
      __v: 0,
      metricIntegrationKey: [],
      balance: 0,
      transactions: [],
      lastPayment: 0,
      validUntil: 0,
      quizDomain: [],
      cbkiller: [],
      idsMaxInApplications: []
    }
  }),

  actions: {
    async fetchUser(): Promise<void> {
      this.user = await API.getUser();
    },
    setUser(state: stateUser, user: user): void {
      state.user = user;
    }
  },
  getters: {
    getUser: (state: stateUser): user => {
      return state.user;
    }
  }
});
